import React, { useEffect, useState } from "react";

import { logoutUser, useAuth } from "../auth/FirebaseAuth";

import { useAppContext } from "../config/AppContext";

import Icon1 from "../icons/Icon";

import SmallSpinner from "../loading/SmallSpinner";
import TaskDisplay from "./TaskDisplay";
import { useSnackbar } from "notistack";
import EducationDisplay from "./EducationDisplay";

function HoverBar({
  actualpage,
  userData,
  orgData,
  masterData,
  local_version,
  override_id = null,
  navigateWorkspace,
  workspaceData,
  handleLogout,
  handleLoginAs,
  workspaces,
}) {
  const { currentUser, loading } = useAuth();
  const { appState, setAppState, resetAppStateLogin } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [task_number_notif, setTaskNumberNotif] = useState(0);
  const [display_tasks, setDisplayTasks] = useState(false);
  const [display_education, setDisplayEducation] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  if (loading || !currentUser || !userData || !orgData) {
    return (
      <div className="flex flex-col items-center justify-center h-screen w-screen">
        <SmallSpinner></SmallSpinner>
      </div>
    ); // Show loading state while checking auth or if currentUser is null
  }

  // Sur la messagerie, les boutons flottants (formation / tâches) se posent
  // par-dessus le champ de saisie en bas à droite et masquent le texte qu'on
  // tape. On les retire de cette page (ils réapparaissent dès qu'on en sort).
  if (actualpage === "message") return null;

  // <div className="flex flex-row  max-w-full pl-1 mr-5 text-gray-800 text-h3  bg-neutral-100   rounded-md  border-1   ">
  //{orgData.name}
  // </div>

  return (
    <div className="flex flex-col  h-full fixed bg-transparent pointer-events-none  ">
      {!workspaceData && (
        <div className="fixed  w-screen h-screen pointer-events-none  left-0 bottom-0">
          <TaskDisplay
            userData={userData}
            orgData={orgData}
            visible={display_tasks}
            handleClickVariant={handleClickVariant}
            prefix={prefix}
            navigateWorkspace={navigateWorkspace}
            setTaskNumberNotif={setTaskNumberNotif}
          ></TaskDisplay>
        </div>
      )}
      {!workspaceData && (
        <div className="fixed  w-screen h-screen pointer-events-none   left-0 bottom-0">
          <EducationDisplay
            userData={userData}
            orgData={orgData}
            visible={display_education}
            handleClickVariant={handleClickVariant}
            prefix={prefix}
            navigateWorkspace={navigateWorkspace}
          ></EducationDisplay>
        </div>
      )}
      {!workspaceData && (
        <div className="fixed  w-screen h-screen pointer-events-none  left-0 bottom-0">
          <div
            onClick={() => setDisplayTasks(!display_tasks)}
            className="absolute  rounded-full pointer-events-auto cursor-pointer hover:shadow-lg hover:scale-105 duration-300 transition-all hover:shadow-neutral-200 bg-black items-center justify-center flex shadow-md p-2 h-12 w-fit bottom-5 right-36"
            style={{
              right: "80px",
              width: "47px",
            }}
          >
            <div className="relative">
              <Icon1
                icon_name={display_tasks ? "down" : "task"}
                size={display_tasks ? 18 : 30}
                fill="white"
              />
              {task_number_notif > 0 && !display_tasks && (
                <div className="absolute bottom-5 left-5 rounded-full w-6 h-6 items-center flex justify-center bg-red-500 text-white tet-h2">
                  {task_number_notif}
                </div>
              )}
            </div>
          </div>
        </div>
      )}{" "}
      {true && (
        <div className="fixed  w-screen h-screen pointer-events-none  left-0 bottom-0">
          <div
            onClick={() => setDisplayEducation(!display_education)}
            className="absolute rounded-full  pointer-events-auto cursor-pointer hover:shadow-lg hover:scale-105 duration-300 transition-all hover:shadow-neutral-200 bg-white items-center justify-center flex shadow-md p-2 h-12 w-fit bottom-5 right-36"
            style={{
              right: "140px",
              width: "47px",
            }}
          >
            <Icon1
              icon_name={display_education ? "down" : "education"}
              size={display_education ? 18 : 30}
              fill="black"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default HoverBar;
